import styled from 'styled-components';

interface InputBorderProps {
	isDenmarkFranchise: boolean;
	buyInAmount: string;
	lowestBuyInAmount: number;
}

export const InputBorder = styled.div<InputBorderProps>`
	background-color: ${({ isDenmarkFranchise, buyInAmount, lowestBuyInAmount }) => {
		return isDenmarkFranchise && buyInAmount !== '' && parseInt(buyInAmount, 10) < lowestBuyInAmount
			? 'rgba(var(--error))'
			: 'rgba(var(--primary))';
	}};
`;

interface InputHintProps {
	buyInAmount: string;
}

export const InputHint = styled.div<InputHintProps>`
	display: block;
	font: var(--caption);
	min-height: 20px;
	padding: 0 0 0 12px;
	margin-top: 4px;
	transition:
		transform 250ms ease-in,
		color 250ms ease-in;
	color: ${({ buyInAmount }) => (buyInAmount !== '' ? 'rgba(var(--error))' : 'rgba(var(--font-supportive))')};
`;

export const Input = styled.input`
	&:focus {
		& ~ .hint {
			color: rgba(var(--font-supportive), 1);
		}
	}
`;
